import React from "react";

export const ServicesDetailsFaq = () => {
  return (
    <div className="accordion-wrap-three">
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Strategic Insights
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              We leverage deep industry knowledge and data-driven analysis to provide actionable insights that 
              empower your business decisions. By understanding market trends, operational gaps, and 
              opportunities, we help you build a roadmap for sustainable growth.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
               Streamlined Processes
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Our solutions are designed to optimize workflows and enhance efficiency. By identifying 
              redundancies and implementing best practices, we streamline operations to save time,
               reduce costs, and improve overall productivity.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Tangible Results
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              We are committed to delivering results that matter. Whether it’s improving performance metrics,
               boosting profitability, or enhancing customer satisfaction, our approach ensures clear and 
               measurable outcomes that align with your goals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
